import { Credentials } from "../models/Credentials";
import { GroupChat } from "../models/GroupChat";
import { Pleb } from "../models/Pleb";
import { PaymentType, Transaction, TransactionStatus } from "../models/Transactions";
import { Wallet } from "./WalletRepository";
import { Event } from "../models/Event";
export class FakeData {
  static getEvent = (): Event => {
    return new Event({
      id: "fakeEventId",
      address: "Fake Address",
      description: "Fake Description",
      startDate: "2025-01-26T18:01:53.787Z",
      endDate: "2025-01-26T18:01:53.787Z",
      pictures: ["fakeImage"],
      thumbnail: "fakeImage",
      coordinates: {
        latitude: 1,
        longitude: 1
      },
      name: "Fake Event",
      image: "fakeImage",
      venue: "Fake Venue",
      timeZone: "Europe/Paris",
      organizer: FakeData.getPleb()
    })
  }

  static getGroupChat = (): GroupChat => {
    return new GroupChat({
      id: "fakeGroupId",
      channelId: "fakeChannelId",
      name: "Fake Group",
      image: "fakeImage",
      members: [FakeData.getPleb()],
      admins: ["fakeAdminId"],
      adminPermissionsEnabled: true
    })
  }

  static getWallet = (): Wallet => {
    return {
      balance: 150000,
      lnurl: "satoshi@example.com"
    }
  }

  static getTransaction = (): Transaction => {
    return {
      status: TransactionStatus.PENDING,
      paymentHash: "fakePaymentHash",
      amount: -10000,
      fee: 100,
      comment: "Fake transaction",
      time: "2025-01-26T18:01:53.787Z",
      read: false,
      type: PaymentType.bulk,
      bulk: {
        name: "Fake bulk payment",
        nbToSend: 10,
        nbSendedSuccess: 5,
        nbSendedError: 1,
      }
    }
  }

  static getCredentials = (): Credentials => {
    return {
      "accessToken": "fakeAccessToken",
      "refreshToken": "fakeRefreshToken",
      "streamToken": "streamToken",
    };
  }

  static getPleb = (): Pleb => {
    return Pleb.currentUserFromJson({
    "_id": "6706d4306349ce9c689b35db",
    "provider": "otp",
    "email": "satoshi@simplelogin.com",
    "roles": [
      "user"
    ],
    "name": "Satoshi Nakamoto",
    "slugChanged": false,
    "pictures": [
      {
        "key": "avatars/1fa958a1-0dab-42d4-b6b7-7a1f6304713f",
        "bucket": "orange-pill-app-dev",
        "mimeType": "image/jpeg",
        "url": ""
      }
    ],
    "location": {
      "type": "Point",
      "coordinates": [
        -69.9248338,
        18.4484434
      ]
    },
    "hideDistance": false,
    "bloam": false,
    "showFeedWithoutLocation": false,
    "sponsor": false,
    "merchant": false,
    "announced": true,
    "createdAt": "2024-10-09T19:06:24.495Z",
    "updatedAt": "2025-01-26T18:01:53.787Z",
    "slug": "satoshi-2",
    "__v": 0,
    "survey": {
      "what": null,
      "when": null,
      "who": null
    },
    "initialSubscriptionId": "sats-yearly",
    "memberNumber": 44166,
    "satSubscription": {
      "id": "sats-yearly",
      "expiresAt": "2222-10-31T00:00:00.000Z",
      "subscribedAt": "2024-10-09T22:36:49.464Z",
      "store": "speed",
      "_id": "6707058162955398225e9616"
    },
    "subscription": {
      "id": "sats-yearly",
      "expiresAt": "2222-10-31T00:00:00.000Z",
      "subscribedAt": "2024-10-09T22:36:49.464Z",
      "store": "speed",
      "_id": "6707058162955398225e9616"
    },
    "address": null,
    "bio": "Fake bio",
    "city": null,
    "gender": null,
    "interests": "freedom",
    "merchantOwnerId": null,
    "nostrPublicKey": null,
    "openingTimes": {},
    "phoneNumber": null,
    "profession": "Web developer",
    "twitterSlug": null,
    "website": null,
    "yob": 1997,
    "zapAddress": "satoshi@walletofsatoshi.com",
    "provisional": false,
    "hasBeenConnectedWithFounder": false,
    "publicPictureURL": "",
    "connectionsCount": 9,
    "merchantOwner": null,
      "id": "6706d4306349ce9c689b35db"
    });
  }
}